export default {"src":"/_next/static/media/TPR.be6c04b6.svg","height":18,"width":18};